import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-credit-card',
  templateUrl: './icon-credit-card.component.html',
  styleUrls: ['./icon-credit-card.component.scss']
})
export class IconCreditCardComponent implements OnInit {

  @Input() cssClass = '';
  
  constructor() { }

  ngOnInit() {
  }

}
